import { render, staticRenderFns } from "./continous.vue?vue&type=template&id=3afc0fa0"
import script from "./continous.vue?vue&type=script&lang=js"
export * from "./continous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports